import React, {Component} from 'react'
import { Redirect, Link } from "react-router-dom"

class PipsyModal extends Component {

	constructor(props) {
		super(props)      
	}

    
	render() {
		return (
			<div className="modal">
                <h3>{this.props.title}</h3>
                {this.props.msg}
            </div>
		)
	}
}

export default PipsyModal
